import { makeStyles, createStyles } from '@material-ui/core'

export const useModelStyles = makeStyles((theme) =>
  createStyles({
    btnAddModelsContainer: {
      position: 'fixed',
      right: 14,
      bottom: 14,
      zIndex: 999
    },

    btnAddModels: {
      background: '#E52428 !important',
      height: '50px',
      padding: '13px 0px 6px 9px',
      minWidth: 'initial',
      width: 'fit-content',
      color: 'white',
      borderRadius: '50%'
    },

    modelTitle: {
      fontFamily: 'Montserrat',
      fontSize: '25px',
      fontWeight: 600,
      lineHeight: '30px',
      letterSpacing: '0em',
      paddingTop: 5
    },

    modelAmountDiv: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      marginBottom: '34px',
      alignItems: 'center',

      [theme.breakpoints.down(960)]: {
        width: 'auto',
        marginBottom: '15px',
        paddingLeft: '24px',
        paddingRight: '24px'
      },

      [theme.breakpoints.down(600)]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        paddingLeft: '0px',
        paddingRight: '10px'
      }
    },

    modelAmount: {
      height: '20px',
      color: '#757575',
      fontFamily: 'Roboto',
      fontSize: '14px',
      weight: '400',
      lineHeight: '20px',
      letterSpacing: '0em',
      width: 'auto',
      marginTop: 4,
      marginLeft: '27px',

      [theme.breakpoints.down(600)]: {
        marginLeft: '0px'
      }
    },

    myModelAmountDiv: {
      marginBottom: '20px',
      [theme.breakpoints.down(960)]: {
        marginBottom: '0px',
        marginTop: '20px',
        marginLeft: '15px'
      }
    },

    myModelAmount: {
      height: '20px',
      width: '150px',
      color: '#757575',
      fontFamily: 'Roboto',
      fontSize: '14px',
      weight: '400',
      lineHeight: '20px',
      letterSpacing: '0em'
    },

    modelDownloadingInfo: {
      height: '240px',
      width: '350px',
      padding: '32px, 16px, 32px, 16px',
      backgroundColor: 'white',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.12)',
      marginTop: '20px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.down(960)]: {
        display: 'none'
      }
    },

    modelIndicatorDivs: {
      width: '323px',
      height: '68px',
      display: 'flex',
      flexDirection: 'column'
    },

    indicatorTitle: {
      fontFamily: 'Roboto',
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: '24px',
      letterSpacing: '0.15000000596046448px'
    },

    noModelIcon: {
      width: '136px',
      [theme.breakpoints.down(500)]: {
        width: '70px'
      }
    },

    searchBar: {
      height: 64,
      boxShadow: '0px 4px 25px rgba(0, 0, 0, 0.1)',
      borderRadius: '13px'
    },

    noModal: {
      width: '100%',
      marginTop: '211px',
      marginBottom: '211px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    },

    indicatorCountAndAddDiv: {
      display: 'flex',
      marginTop: '16px',
      justifyContent: 'space-between'
    },

    indicatorCount: {
      fontFamily: 'Roboto',
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '16px',
      letterSpacing: '0.4000000059604645px',
      color: '#9E9E9E'
    },

    AddButton: {
      fontFamily: 'Roboto',
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '16px',
      letterSpacing: '0.4000000059604645px',
      color: '#2E86BD'
    },

    indicator: {
      marginTop: '8px',
      ['& div']: {
        backgroundColor: '#2196F3'
      }
    },

    tabletBtn: {
      width: 184
    },

    btnHeight: {
      [theme.breakpoints.up('sm')]: {
        display: 'none'
      }
    },

    tooltip: {
      backgroundColor: 'white',
      fontSize: '10px',
      color: 'black'
    },

    searchMe: {
      '&>div>div': {
        height: 42
      }
    },

    selectMe: {
      [theme.breakpoints.up('md')]: {
        marginBottom: 20
      }
    },

    paginationBlock: {
      margin: '20px 0',
      display: 'flex',
      justifyContent: 'center'
    },

    noData: {
      width: '100%',
      height: '50vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },

    noDataContent: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
      alignItems: 'center',
      fontSize: 24,
      maxWidth: '783px',
      padding: '0 15px'
    },

    iconNoData: {
      maxWidth: 100,
      maxHeight: 100,
      marginBottom: 10
    },

    btnMoreModelBlock: {
      width: '100%',
      textAlign: 'center'
    },

    btnMoreModel: {
      margin: '80px 0',
      color: '#fff!important',
      background: '#2E86BD!important',
      [theme.breakpoints.down('xs')]: {
        margin: '30px 0',
        padding: '10px 14px'
      }
    },

    paginationBlockAuthor: {
      margin: '80px 0',
      display: 'flex',
      justifyContent: 'center',
      paddingLeft: 171,
      [theme.breakpoints.down('xs')]: {
        paddingLeft: 0,
        margin: '30px 0'
      }
    },

    toolbarModelAuthor: {
      [theme.breakpoints.down('xs')]: {
        display: 'none'
      }
    },

    sidebarContent: {
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        justifyContent: 'space-between'
      }
    },

    footer: {
      [theme.breakpoints.down('xs')]: {
        marginBottom: 76.5
      }
    },

    sidebarModal: {
      width: '375px',
      top: '65px',
      border: 'none',
      'overflow-y': 'auto',

      '& .makeStyles-leftColumnRoot-47': {
        backgroundColor: 'white'
      },

      [theme.breakpoints.down(600)]: {
        width: '100%'
      }
    },

    unNameContainer: {
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
      marginBottom: '40px',

      [theme.breakpoints.down(960)]: {
        justifyContent: 'space-between',
        paddingRight: '15px',
        marginBottom: 0
      },

      [theme.breakpoints.down(600)]: {
        alignItems: 'end',
        paddingRight: '0px'
      }
    },

    modalHeader: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      padding: 16,
      background: '#F6F6F6'
    },

    filterTitle: {
      fontFamily: 'Montserrat',
      fontSize: '20px',
      fontWeight: 600,
      lineHeight: '24px',
      letterSpacing: '0em'
    }
  })
)
